/**
 * Created by Thram on 31/08/16.
 */
global._ = require("lodash");
let tags = require('bulk-require')(__dirname, ['../../tags/**/*.tag', '../tags/**/*.js']);